import React, {useState} from "react";
import "./style.css";
import { PaymentFastMethods } from "./PaymentFastMethods/PaymentFastMethods";
import {PAYMENT_TYPE_PAYPAL, PAYMENT_TYPE_STRIPE} from "../../../../../../../const/Pay";
import WalletPayWrapper from "../../../../../../../components/WalletPay/WalletPayWrapper";
import { Image } from "../../../../../../../components/Image";
import { buildLocalizedPath } from "../../../../../../../utils/common";

export const MobilePayMethodsPopup = (props) => {
  const [display, setDisplay] = useState(0);
  const [walletPaymentTypes, setWalletPaymentTypes] = useState({ applePay: false, googlePay: false });
  const { showPopup, clickPaypalPay, closePaymentPopup, price, discount, logPaymentMethodClick, weightLossFormData, logEvent } = props;
  const planTitle = price.dynamicCycleSubscription
    ? `${price.week}-Week Trial`
    : `${price.getFinalWeek()}-Week Plan`;
  const originPrice = price.getOriginPrice();
  const currentPrice = price.getPrice();
  const showOriginPrice = !!originPrice && originPrice !== currentPrice;

  const choosePaymentMethod = (value) => {
    logPaymentMethodClick(value === 1 ? PAYMENT_TYPE_STRIPE : PAYMENT_TYPE_PAYPAL);
    setDisplay(value);
  };

  const handleWalletPaymentSuccess = ({ sessionId }) => {
    window.location.href = `${window.location.origin}${buildLocalizedPath(`/pay/verify?session_id=${sessionId}`)}`;
  };

  const handleWalletPaymentError = (errorMessage) => {
    console.error("Wallet payment error:", errorMessage);
  };

  const handleWalletAvailabilityChange = (walletTypes) => {
    setWalletPaymentTypes(walletTypes);
  };

  return (
    <div className="pay-methods-popup-mobile" data-model-id="18137:75" style={{display: showPopup ? "" : "none"}}>
      <div className="popup-sheet">
        <div className="popup-header">
          <div className="popup-title">Select payment method</div>

          <div className="popup-close">
            <Image
              className="popup-close-icon"
              alt="Clear"
              src="/static/image/questionnaire/weight-loss/payMethodsPopup/clear-24px.png"
              onClick={closePaymentPopup}
            />
          </div>
        </div>

        <div className="popup-plan-card">
          <div className="popup-plan-image-wrap">
            <Image
              src="/static/image/questionnaire/weight-loss/payMethodsPopup/price-info-image.jpg"
              alt={planTitle}
              className="popup-plan-image"
            />
          </div>

          <div className="popup-plan-summary">
            <div className="popup-plan-title">{planTitle}</div>
            <div className="popup-plan-prices">
              {showOriginPrice && <div className="popup-plan-origin">{originPrice}</div>}
              <div className="popup-plan-current">{currentPrice}</div>
            </div>
          </div>
        </div>

        <div className="payment-options" style={{display: display !== 0 ? "none" : ""}}>
          <div className="paypal-info">
            <div className="paypal-option">
              <Image src="/static/image/questionnaire/weight-loss/payMethodsPopup/paypal-icon.png" alt="Paypal icon" className="img" />

              <div className="paypal-copy">
                <div className="payment-title">Fast payments</div>

                <p className="paypal-description">
                  The safer, easier way to pay
                </p>
              </div>
            </div>

            <div className="payment-action">
              <div className="bottom" onClick={clickPaypalPay}>
                <Image src="/static/image/questionnaire/weight-loss/payMethodsPopup/create-a-custom-paypal-logo-and-buttons-paypal-in-1.png" alt="PayPal" className="create-a-custom" />

                <div className="buy-now">Buy now</div>
              </div>

              <WalletPayWrapper
                price={price}
                discount={discount}
                weightLossFormData={weightLossFormData}
                onPaymentSuccess={handleWalletPaymentSuccess}
                onPaymentError={handleWalletPaymentError}
                onWalletAvailabilityChange={handleWalletAvailabilityChange}
                logEvent={logEvent}
              />
            </div>
          </div>

          <div className="credit-card-info" onClick={() => { choosePaymentMethod(1); }}>
            <div className="credit-card-option">
              <div className="credit-card-details">
                <Image src="/static/image/questionnaire/weight-loss/payMethodsPopup/credit-card-icon.png" alt="Credit card icon" className="img" />

                <div className="payment-title">Credit card</div>
              </div>

              <Image src="/static/image/questionnaire/weight-loss/payMethodsPopup/credit-card-logos.png" alt="Credit card logos" className="credit-card-logos" />
            </div>
          </div>
        </div>

        <PaymentFastMethods
          display={display}
          setDisplay={choosePaymentMethod}
          walletPaymentTypes={walletPaymentTypes}
          {...props}
        />
      </div>
    </div>
  );
};
